import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Layout from '../App/layout'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ContentLayout from '../../components/utility/layoutContent'

import JournalEntriesIndexContainer from './JournalEntriesIndexContainer'

class JournalEntryIndexPage extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired
    }

    componentDidMount() {
        document.title = 'Journal Entries | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                    { path: '/journal_entries', name: 'Journal Entries' }
                ]}>
                    <ContentLayout>
                      <JournalEntriesIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default JournalEntryIndexPage
